import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class KeyboardService {
    constructor() {}

    public isMinus(code: number) {
        return code === 189;
    }

    public isNumpad(code: number) {
        return code > 95 && code < 106;
    }

    public isDigit(code: number) {
        return code > 47 && code < 58;
    }

    public isNumber(code: number) {
        return this.isNumpad(code) || this.isDigit(code);
    }

    public isBackspace(code: number) {
        return code === 8;
    }

    public isDelete(code: number) {
        return code === 46;
    }

    public isDot(code: number) {
        return code === 190 || code === 110;
    }

    public isTab(code: number) {
        return code === 9;
    }

    public isDown(code: number) {
        return code === 40;
    }

    public isLeft(code: number) {
        return code === 37;
    }

    public isRight(code: number) {
        return code === 39;
    }

    public isUp(code: number) {
        return code === 38;
    }

    public isEnter(code: number) {
        return code === 13;
    }
}
